import { render, staticRenderFns } from "./plOrderStatementOfAccount.vue?vue&type=template&id=d7874a9c&scoped=true"
import script from "./plOrderStatementOfAccount.vue?vue&type=script&lang=js"
export * from "./plOrderStatementOfAccount.vue?vue&type=script&lang=js"
import style0 from "./plOrderStatementOfAccount.vue?vue&type=style&index=0&id=d7874a9c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7874a9c",
  null
  
)

export default component.exports